'use strict';

const $ = require('jquery');

class Popup {

    constructor() {

        require('./../../../../build/node_modules/@components/magnific-popup/dist/jquery.magnific-popup.js');

        $('[data-popup="video"]').magnificPopup({
            disableOn: 600,
            type: 'iframe',
            closeMarkup: '<span title="%title%" class="mfp-close">&#215;</span>'
        });

        $('.book-online').magnificPopup({
            type: 'iframe',
            verticalFit: true,
            mainClass: 'mfp-fade mfp-bookingSelector',
            removalDelay: 160,
            preloader: false,
            closeMarkup: '<button class="mfp-close">&#215;<span class="sr-only">%title%</span></button>',
            tClose: 'Sluiten',
            tLoading: 'Laden...',
            fixedContentPos: false,
            closeOnBgClick: true,
            enableEscapeKey: true
        });

    }

}

module.exports = Popup;
